export function mobilePhoneZH(value) {
  var reg = /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/;
  return {
    value: !!((value === '' || reg.test(value))),
    text: '请输入有效的手机号'
  };
}
export function verificationcode(value) {
  var reg = /^\d{6}$/;
  return {
    value: !!((value === '' || reg.test(value))),
    text: '请输入六位数字的验证码'
  };
}
